const NoSignalIcon = ({ color, secondaryColor, ariaLabel }: { color?: string; secondaryColor?: string; ariaLabel?: string }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9997 4H17.4734V12.0274C17.6465 12.0093 17.8222 12 18 12C18.711 12 19.3873 12.1484 19.9997 12.4159V4ZM13.2629 15.3958C13.0924 15.8993 13 16.4389 13 17C13 17.5611 13.0924 18.1007 13.2629 18.6042V20H10.7366V10H13.2629V15.3958ZM16.6313 12.1896C15.6234 12.4759 14.7452 13.0703 14.105 13.8646V7H16.6313V12.1896ZM9.89448 13H7.36816V20H9.89448V13ZM4 16H6.52632V20H4V16Z"
        fill={secondaryColor ?? 'black'}
      />
      <path
        d="M19.7949 20L21 18.7949L19.1924 16.9958L21 15.1966L19.7949 14L17.9958 15.7992L16.1966 14L15 15.1966L16.7992 16.9958L15 18.7949L16.1966 20L17.9958 18.1924L19.7949 20Z"
        fill={color ?? '#B00020'}
      />
    </svg>
  )
}

export default NoSignalIcon
